export default "__VITE_ASSET__DSy$7lYT__"